export default __webpack_public_path__ + "static/media/Lin.51e733fc.png";